"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setCustomLoader = void 0;
// Custom loader is an object being pushed into array
var loader = [];

var setCustomLoader = function setCustomLoader(customLoader) {
  return loader.push(customLoader);
};

exports.setCustomLoader = setCustomLoader;
var _default = loader;
exports.default = _default;